// extracted by mini-css-extract-plugin
module.exports = {"checkoutFlowSpinner":"CheckoutFlowSpinner_checkoutFlowSpinner__T6D3T"};